import queryString from 'query-string'
import api from '@utils/api'
import {http, $http} from '@utils'

export default {
    namespaced: true,
    state:{
        stepId: 1,
        regInfo: {

        }
    },
    mutations:{
        setStepId(state, id) {
            state.stepId = id ;
        },
        setRegInfo(state, info) {
            state.regInfo = info
        }
    },
    actions:{
        async doRegister({commit}, { regType, userName, password, pwdConfirm, phone, email, nickName,buzzCode,
            buzzType,
            buzzId,
            buzzName }) {
            const param = JSON.stringify({
                userName, password, pwdConfirm, phone, email, nickName, buzzCode,
                buzzType,
                buzzId,
                buzzName
            })

            const res = await $http.post(`${api.mainHost}/portal-api/user/register.do`, queryString.stringify({param, regType}), {
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            })
            return res
        }
    }
}